import { render, staticRenderFns } from "./ItemStatistic.vue?vue&type=template&id=2db04310&scoped=true&"
import script from "./ItemStatistic.vue?vue&type=script&lang=js&"
export * from "./ItemStatistic.vue?vue&type=script&lang=js&"
import style0 from "./ItemStatistic.vue?vue&type=style&index=0&id=2db04310&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db04310",
  null
  
)

export default component.exports